import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { CONSTANTS } from 'src/app/shared/constants/constants';

@Component({
  selector: 'app-device-info',
  templateUrl: './device-info.component.html',
  styleUrls: ['./device-info.component.scss'],
})
export class DeviceInfoComponent implements OnInit {
  /**
   * all necessary input get values from parent
   */
  @Input() formGroupName!: string;
  CONSTANTS = CONSTANTS;
  @Input() dialogRef?: any; //close event of parent component
  @Input() stepper!: number;
  @Input() parentType!: string;
  @Input() deviceType!: string;
  @Output() stepperChange = new EventEmitter<number>();
  deviceKind!: string;
  formGroup!: FormGroup;
  readonly LANG_CONST = LANG_CONST;
  submited: boolean = false;
  get formInstance() {
    return this.formGroup.controls;
  }
  constructor(private rootFormGroup: FormGroupDirective) {}

  /**
   * @description this is onInit life cycle method
   */
  ngOnInit(): void {
    this.formGroup = this.rootFormGroup.control.get(
      this.formGroupName
    ) as FormGroup;
    this.deviceKind = this.formInstance?.deviceKind.value
      ? this.formInstance?.deviceKind.value
      : CONSTANTS.IPREADER;
  }
  /**
   * @description close modal dialogue with help of material service
   * @returns void
   */
  closeDialog(): void {
    this.dialogRef?.close();
  }

  /**
   * @description navigate to back screen
   * @returns void
   */
  navigateBack(): void {
    this.stepperChange?.emit((this.stepper = 1));
  }
}
